import { computed } from 'vue'

interface BaseProps<T> {
  modelValue: T
  value?: any
}

interface Emit<T> {
  (evt: 'update:modelValue', modelValue: T): void
}

export const useCheckbox = <T extends boolean | any[]>(
  props: BaseProps<T>,
  emit: Emit<T>
) => {
  const checked = computed(() =>
    typeof props.modelValue === 'boolean'
      ? props.modelValue
      : props.modelValue.includes(props.value)
  )

  const toggle = () => {
    if (typeof props.modelValue === 'boolean') {
      emit('update:modelValue', !checked.value as T)
      return
    }

    const newArray = checked.value
      ? props.modelValue.filter(value => value !== props.value)
      : props.modelValue.concat(props.value)

    emit('update:modelValue', newArray as T)
  }

  return { checked, toggle }
}
